// hooks/useAppNavigation.ts
import { useState, useCallback } from 'react';

export type AppView = 'hero' | 'canvas' | 'calendario' | 'maps' | 'spotify';

export const useAppNavigation = (initialView: AppView = 'hero') => {
  const [currentView, setCurrentView] = useState<AppView>(initialView);
  const [previousView, setPreviousView] = useState<AppView | null>(null);
  
  const navigateTo = useCallback((view: AppView) => {
    setPreviousView(currentView);
    setCurrentView(view);
  }, [currentView]);
  
  const goBack = useCallback(() => {
    if (previousView) {
      setCurrentView(previousView);
      setPreviousView(null);
    }
  }, [previousView]);
  
  return {
    currentView,
    previousView,
    navigateTo,
    goBack
  };
};